import { ProviderEventHandlers } from '@/features/event-handlers/wrapper-event-handlers/provider-events/types';
import { GenericProvider, Provider } from '@/features/game-context/types';
import { useAristocratEventHandlers } from '@/features/game-window-integration/providers/aristocrat/use-aristocrat-event-handlers';
import useAwagerEventHandlers from '@/features/game-window-integration/providers/awager/use-awager-event-handlers';
import { useDgcEventHandlers } from '@/features/game-window-integration/providers/dgc/use-dgc-event-handlers';
import { useFusionEventHandlers } from '@/features/game-window-integration/providers/fusion/use-fusion-listener';
import { useGenericProviderEventHandlers } from '@/features/game-window-integration/providers/generic-provider/use-generic-provider-listener.ts';
import { isGenericProvider } from '@/features/game-window-integration/providers/generic-provider/utils.ts';
import { usePlaytechEventHandlers } from '@/features/game-window-integration/providers/playtech/use-playtech-event-handlers';
import { usePragmaticEventHandlers } from '@/features/game-window-integration/providers/pragmatic/use-pragmatic-listener';
import { useEveriEventHandlers } from '@/features/game-window-integration/use-everi-event-handlers';
import { useEvolutionEventHandlers } from '@/features/game-window-integration/use-evolution-event-handlers';
import { useIgtEventHandlers } from '@/features/game-window-integration/use-igt-event-handlers';
import { useLnwEventHandlers } from '@/features/game-window-integration/use-lnw-event-handlers';

export const useHandleWrapperProviderEventMapper = (
  provider: Provider | GenericProvider | undefined,
): ProviderEventHandlers => {
  const notImplemented = {
    providerEventHandler: () => {},
    wrapperEventHandler: () => {},
  };

  const everiHandlers = { ...useEveriEventHandlers() };
  const igtHandlers = { ...useIgtEventHandlers() };
  const aristocratHandlers = { ...useAristocratEventHandlers() };
  const evolutionHandlers = { ...useEvolutionEventHandlers() };
  const dgcHandlers = { ...useDgcEventHandlers() };
  const lnwHandlers = { ...useLnwEventHandlers() };
  const awagerHandlers = { ...useAwagerEventHandlers() };
  const playtechHandlers = {
    ...usePlaytechEventHandlers(provider as Provider),
  };
  const pragmaticHandlers = { ...usePragmaticEventHandlers() };
  const genericHandlers = {
    ...useGenericProviderEventHandlers(provider as GenericProvider),
  };
  const fusionHandlers = { ...useFusionEventHandlers() };

  const handlerMap = {
    [Provider.EVERI]: everiHandlers,
    [Provider.IGT]: igtHandlers,
    [Provider.ARISTOCRAT]: aristocratHandlers,
    [Provider.EVOLUTION]: evolutionHandlers,
    [Provider.DGC]: dgcHandlers,
    [Provider.LNW]: lnwHandlers,
    [Provider.AWAGER]: awagerHandlers,
    [Provider.PLAYTECH]: playtechHandlers,
    [Provider.PLAYTECH_POKER]: playtechHandlers,
    [Provider.PRAGMATIC]: pragmaticHandlers,
    [Provider.FUSION]: fusionHandlers,
  };
  if (!provider) return notImplemented;

  if (isGenericProvider(provider) && !handlerMap[provider])
    handlerMap[provider] = genericHandlers;

  return handlerMap[provider] || notImplemented;
};
